<script>
import cartInsurances from '@/components/cart/insurances/Index.vue'
import cartCancelInsurance from '@/components/cart/cancelInsurance/Index.vue'
import cartExcursions from '@/components/cart/excursions/Index.vue'
import cartTransfers from '@/components/cart/transfers/Index.vue'
import cartFlights from '@/components/cart/flights/Index.vue'
import cartVisas from '@/components/cart/visas/Index.vue'
import chat from './views/Chat.vue'
import bookings from './views/Bookings.vue'
import tourists from './views/Tourists.vue'
import orderSidebar from './views/OrderSidebar.vue'
import additionalSidebar from './views/AdditionalSidebar.vue'
import documents from '@/components/orders/views/Documents.vue'
import orderFeedback from './views/OrderFeedback.vue'
import PaymentMethodSelect from '@/components/orders/views/PaymentMethodSelect.vue'

export default {
  name: 'order',
  components: {
    cartInsurances,
    cartCancelInsurance,
    cartExcursions,
    cartTransfers,
    cartFlights,
    cartVisas,
    chat,
    bookings,
    tourists,
    orderSidebar,
    additionalSidebar,
    documents,
    orderFeedback,
    PaymentMethodSelect
  },
  metaInfo() {
    return {
      title: `Заказ №${this.$route.params.orderId}`
    }
  },
  computed: {
    hasBookedServices() {
      return this.$store.getters['order/hasBookedServices']
    },
    getBookingsServices() {
      return this.$store.getters['order/getBookingsServices']
    },
    getNumberOfTourists() {
      return this.$store.getters['order/getNumberOfTourists']
    },
    order() {
      return this.$store.getters['order/getOrderInfo']
    },
    orderId() {
      return this.$route.params.orderId
    },
    isLoading() {
      return this.$store.getters['order/isLoading']
    },
    isLoadingError() {
      return this.$store.getters['order/isLoadingError']
    },
    documents() {
      return this.$store.getters['order/getDocuments']
    }
  },
  watch: {
    order: {
      // eslint-disable-next-line
      handler: function (val, oldVal) {
        this.setSearchField()
      },
      deep: true
    },
    '$store.state.cart.medicalInsurance.insurances.current.slug'(val, oldVal) {
      this.getServicePenalties({
        val,
        oldVal,
        service: 'medicalInsurance',
        apiModuleName: 'medicalInsurances',
        label: 'Медицинская страховка'
      })
    },
    '$store.state.cart.transfer.transfers.current.slug'(val, oldVal) {
      if (
        this.$store.state.cart.transfer.transfers.current.transferId != null
        && this.$store.state.cart.transfer.transfers.current.vehicleId != null
      ) {
        this.getServicePenalties({
          val,
          oldVal,
          service: 'transfer',
          apiModuleName: 'transfers',
          label: 'Трансфер'
        })
      }
    }
  },
  created() {
    const { orderId: id } = this.$route.params
    const { currency } = this.$route.query
    const { orderCurrency } = this.order

    this.$store.dispatch('order/getOrder', {
      id,
      params: {
        currency: currency || orderCurrency
      }
    })

    this.$store.commit('order/setChat', {
      isLoading: true
    })

    this.$store.dispatch('order/getMessages', {
      orderId: id
    })
  },
  methods: {
    setSearchField() {
      const services = Object.keys(this.getBookingsServices)

      if (services.length) {
        this.$store.commit('cart/updateServiceField', {
          target: 'mainService',
          // костыль пока бэк не поправит поля в ответе
          /* eslint-disable */
          value: services.includes('hotels')
            ? 'hotels'
            : services[0]
          /* eslint-enable */
        })

        this.$store.commit('cart/updateServiceField', {
          target: 'hotel.info.city',
          value: services.includes('hotels')
            ? {
              ...this.getBookingsServices.hotels[0].details.city
            }
            : {
              id: null,
              name: null
            }
        })
        this.$store.commit('cart/updateServiceField', {
          target: 'hotel.info.id',
          value: services.includes('hotels')
            ? this.getBookingsServices.hotels[0].details.id
            : null
        })
        this.$store.commit('cart/updateServiceField', {
          target: 'hotel.info.name',
          value: services.includes('hotels')
            ? this.getBookingsServices.hotels[0].details.name
            : null
        })
        this.$store.commit('cart/updateServiceField', {
          target: 'hotel.form.checkInDate',
          value: this.order.startDate
        })
        this.$store.commit('cart/updateServiceField', {
          target: 'hotel.form.duration',
          value: this.order.durationInDays
        })
        this.$store.commit('cart/updateServiceField', {
          target: 'hotel.form.rooms',
          value: [{
            adults: this.getNumberOfTourists.adults,
            children: this.getNumberOfTourists.children,
            ages: this.getNumberOfTourists.ages
          }]
        })
        this.$store.commit('cart/updateServiceField', {
          target: 'hotel.info.country',
          value: this.order.country
        })
      }
    },
    getServicePenalties(data) {
      const {
        val,
        oldVal,
        service,
        apiModuleName,
        label
      } = data

      if (val !== null && (val !== oldVal)) {
        this.$store.dispatch('cart/getServicePenaltiesForAll', {
          ids: {
            ...this.$store.getters['cart/getIds'][service]
          },
          serviceName: service,
          apiModuleName,
          label
        })
      } else if (val === null && oldVal !== null) {
        this.$store.commit('cart/removeServiceFromAllPenalties', { service })
      }
    },
    statusName(statusId) {
      return this.$store.getters['order/getInclude'].orderStatuses[statusId]
    },
  }
}
</script>

<template>
  <div class="order">
    <div class="order__header">
      <h1 class="order__header-title">
        Заказ № {{ orderId }}
        <span
          v-if="hasBookedServices"
          class="order__header-status"
        >
          {{ statusName(order.status) }}
        </span>
      </h1>
    </div>
    <div class="order__content">
      <h2 v-if="isLoadingError">
        Произошла ошибка при загрузке заказа № {{ orderId }}<br>
        Перезагрузите страницу или попробуйте позже
      </h2>
      <div
        v-else
        class="order__main"
      >
        <chat />
        <bookings />
        <div
          v-if="getNumberOfTourists.total"
          class="cart"
        >
          <cart-flights v-if="!getBookingsServices.aviatickets" />
          <cart-excursions />
          <cart-insurances v-if="!getBookingsServices.insurances" />
          <cart-cancel-insurance v-if="!getBookingsServices.insurances" />
          <cart-transfers v-if="!getBookingsServices.transfers" />
          <cart-visas v-if="!getBookingsServices.visas && getBookingsServices.hotels" />
        </div>
        <tourists />
      </div>
      <div
        v-if="!isLoading"
        class="order__sidebar"
      >
        <order-sidebar />
        <additional-sidebar />
        <order-feedback v-if="!isLoading && hasBookedServices" />
        <div
          v-if="!isLoading && hasBookedServices"
          class="sidebar app-sidebar"
        >
          <div class="sidebar__content">
            <p class="sidebar__title">
              Документы
            </p>
            <documents
              store-module="order"
              getter-name="getServiceField"
              setter-name="setServiceField"
              target="documentsForm"
              :documents="documents"
              :order-id="orderId"
            />
          </div>
        </div>
      </div>
    </div>
    <payment-method-select />
  </div>
</template>
